<template>
    <div class="w-full relative">
        <div v-if="isWorking"  class="absolute w-full panel bg-white/40 dark:bg-neutral-950/40 p-1 z-70">
            <LoadingData :message="message" />
        </div>
        <div v-else-if="error" 
             class="w-full error text-center whitespace-normal truncate p-1" 
             :class="hasClearErrorHandler ? 'cursor-pointer hover:opacity-80' : ''"
             @click="hasClearErrorHandler && emit('clearError')">{{error}}</div>
    </div>
</template>

<script>
import { computed, getCurrentInstance } from 'vue'
export default {
    props:{
        isWorking:{type:Boolean,default:false},
        error:{type:String,default:null},
        message:{type:String,default:null}
    },
    emits:['clearError'],
    setup (_, { emit }) {
        const instance = getCurrentInstance()
        const hasClearErrorHandler = computed(() => !!instance?.vnode?.props?.onClearError)
        return {
            emit,
            hasClearErrorHandler
        }
    }

}
</script>

<style>

</style>